import { isFeatureActive } from '../util.js';

$(function () {
    // Dependent on that vendor/toc/bootstrap-toc.js has set ids of headings
    const $headings = $('h2[id], h3[id]');
    if ($headings.length) {
        $('#find-on-page-responsive').removeClass('d-none').addClass('d-flex');
    }
    const $dropup = $('#find-on-page-responsive .menu-dropup');
    const linksMarkup = $headings
        .get()
        .map((h) => `<a class="d-block py-2 text-dark" href="#${h.id}">${h.innerText}</a>`)
        .join('');

    $dropup.html(linksMarkup);

    const expandBadge = ($badge) =>
        $badge
            .attr('aria-expanded', 'true')
            .removeClass('badge-primary-light')
            .addClass('badge-primary');

    const collapseBadge = ($badge) =>
        $badge
            .attr('aria-expanded', 'false')
            .removeClass('badge-primary')
            .addClass('badge-primary-light');

    $('#find-on-page-responsive a.badge').on('click', (event) => {
        $dropup.toggle();

        const $badge = $(event.currentTarget);
        if ($dropup.is(':visible')) {
            expandBadge($badge);
        } else {
            collapseBadge($badge);
        }
    });

    $('#find-on-page-responsive .menu-dropup').on('click', 'a', () => {
        $dropup.hide();
        collapseBadge($('#find-on-page-responsive a.badge'));
    });
});
